import { render, staticRenderFns } from "./ConfigPage.vue?vue&type=template&id=3b9c86ef&scoped=true&"
import script from "./ConfigPage.vue?vue&type=script&lang=js&"
export * from "./ConfigPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c86ef",
  null
  
)

export default component.exports